import carro from './carro'

export const AuthLogo = carro

export default AuthLogo
